import {
  fail,
  mergeResults,
  ok,
  requireEnum,
  requireLocalizedString,
  type ValidationResult,
} from "../contentImport/validationHelpers";
import {
  NOTIFICATION_DEF_IMPORT_TYPES,
  type NotificationDefImportItem,
} from "./types";

function rejectImportDocumentId(
  item: Record<string, unknown>
): ValidationResult {
  if ("id" in item) {
    return fail(
      '"id" is not allowed in import JSON; upsert uses "type" instead'
    );
  }
  return ok;
}

export function validateNotificationDefImportItem(
  item: NotificationDefImportItem
): ValidationResult {
  const record = item as unknown as Record<string, unknown>;
  return mergeResults(
    rejectImportDocumentId(record),
    requireEnum(record.type, "type", NOTIFICATION_DEF_IMPORT_TYPES),
    requireLocalizedString(record.title, "title"),
    requireLocalizedString(record.body, "body")
  );
}

export function findDuplicateTypesInFile(
  items: NotificationDefImportItem[]
): ValidationResult {
  const seen = new Set<string>();
  for (const item of items) {
    const type = typeof item.type === "string" ? item.type : "";
    if (!type) {
      continue;
    }
    if (seen.has(type)) {
      return fail(`Duplicate type in file: "${type}"`);
    }
    seen.add(type);
  }
  return ok;
}
